import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { transactionInternalApi } from '../apis';
import { InternalApiTransactionByIdsQuery } from '../api-internal';

export const useQueryTransactionByIds = (query: InternalApiTransactionByIdsQuery) =>
  useQuery({
    queryKey: ['transactionsByIds', JSON.stringify(query)],
    queryFn: () =>
      transactionInternalApi.findTransactionByIdsInternal({
        internalApiTransactionByIdsQuery: query,
      }),
    enabled: query.ids.length !== 0,
    placeholderData: keepPreviousData,
  });
